import React from 'react';

import OutputText from '@ey/canvascoreservices/OutputText';

const prop = 'pspIndexes';

export const config = (labels) => ({
	id: `${prop}Column`,
	label: labels.columns[prop],
	propName: 'pspIndexes',
	width: 'var(--px-400)',
	customCell: (item) => {
		const isEmpty = !(item.pspIndexes.length > 0);
		let value = '-';
		if (!isEmpty) value = item.pspIndexes.map(({pspIndexTitle}) => pspIndexTitle).join(', ');

		return (
			<OutputText body2 light ellipsis title={value} multilineEllipsis={2}>
				{value}
			</OutputText>
		);
	}
});
